<template>
  <div class="card">
    <div class="form-group row">
      <div class="col-md-12">
        <el-input type="search" name="search" placeholder="Search Form Fields" clearable v-model="searchQuery" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" id="dynamic-fields-table">
        <el-table class="wrap-whole-words"
                  :data="queriedData"
                  row-key="label"
                  border
                  row-class-name="draggable"
                  id="task-type-field-table"
                  style="width: 100%; margin-top: 10px;">
          <el-table-column v-for="column in fieldTableColumns"
                           :key="column.label"
                           :min-width="column.minWidth"
                           :prop="column.prop"
                           :label="column.label">
          </el-table-column>
          <el-table-column
            width="110"
            label="Actions">
            <template slot-scope="props">
              <p-button type="success" size="sm" icon @click="editFormField(props.row)">
                <i class="fa fa-edit"></i>
              </p-button>
              <p-button type="danger" size="sm" icon @click="removeFormField(props.row)" style="margin-left: 5px;">
                <i class="fa fa-times"></i>
              </p-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {TabPane, Tabs} from 'element-ui'
import {mapGetters} from 'vuex'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import {notifyError, notifySuccess} from 'src/utilities/utils'
import {NO_CONTENT, OK} from 'http-status-codes'

export default {
  props: ['data'],
  components: {
    PSwitch,
    Tabs,
    TabPane
  },
  computed: {
    ...mapGetters({
      tableData: 'inspectorApp/formFields/results',
    }),
    queriedData() {
      if (!this.searchQuery) {
        return this.tableData
      }
      return this.tableData
        .filter((row) => {
          let isIncluded = false

          if (row.label) {
            let rowValue = row.label.toString().toLowerCase()
            if (rowValue.includes && rowValue.includes(this.searchQuery.trim().toLowerCase())) {
              isIncluded = true
            }
          }

          return isIncluded
        })
    }
  },
  data() {
    return {
      toDelete: null,
      searchQuery: '',
      fieldTypes: [
        {
          value: 'Input',
          label: 'Input'
        },
        {
          value: 'Checkbox',
          label: 'Checkbox'
        },
        {
          value: 'GlobalUserPreference',
          label: 'User Preference'
        }
      ],
      fieldTableColumns: [
        {
          prop: 'label',
          label: 'Label',
          minWidth: 105
        },
        {
          prop: 'key',
          label: 'Key',
          minWidth: 95
        },
        {
          prop: 'component',
          label: 'Field Type',
          minWidth: 80
        }
      ],
      addFieldLabel: null,
      addFieldKey: null,
      addFieldType: 'Input'
    }
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    editFormField(formField) {
      this.$eventHub.$emit('show-modal-1', 'Form Field', formField, '600px')
      this.$forceUpdate()
    },
    async removeFormField(formField) {
      this.toDelete = formField.id
      let showButton = false
      let message = ''

      const response =  await this.$store.dispatch('inspectorApp/formFieldBlocks/fetchByFormFieldId', formField.id)

      if (OK !== response.status) {
        notifyError(this, 'Failed to fetch Form Fields or see if <strong>' + formField.label + '</strong> is in use. Unable to delete Form Field.')
        return
      }
      if (response.data.length > 0) {
        message = 'You can not delete <strong>' + formField.label + '</strong> as it is in use by at least one form field block.'
        this.showConfirmDelete(formField, message, showButton)
        return
      }
      message = 'Are you sure you want to delete <strong>' + formField.label + '</strong>? This will completely remove the field.'
      showButton = true
      this.showConfirmDelete(formField, message, showButton)
    },
    showConfirmDelete(formField, message, showButton) {
      const payload = {
        message,
        entity: formField,
        delete: this.delete,
        showButton
      }
      this.$eventHub.$emit('show-modal-1', 'Confirm Delete', payload, '600px')
    },
    async delete() {
      const response = await this.$store.dispatch('delete', {
        endpoint: 'form-fields',
        id: this.toDelete
      })
      if (NO_CONTENT === response.status) {
        this.$store.commit('inspectorApp/formFields/delete', this.toDelete)
        notifySuccess(this, 'Form Field Deleted Successfully')
        return
      }
      notifyError(this, 'Error Deleting Form Field')
    }
  },
  async mounted() {
    const response = await this.$store.dispatch('inspectorApp/formFields/fetchAll')

    if (OK !== response.status) {
      notifyError(this, 'Failed to load InspectorApp fields')
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow: none;
}
</style>
